<template>
  <header id="header" v-if="showHeader">
    <div class="container-fluid">
      <div class="row" v-if="loginHeader === true">
        <div class="col-md-6 align-self-center">
        <div></div>
          <a href="#" class="logo position-relative">
            <img v-if="businessLogo" :src="businessLogo" style="width: 150px !important; height: 20px !important" /> 
           <!-- <img v-if="systemName" :src="`${urlServer}/files/${systemName}`" style="width: 70px !important; position: absolute; bottom: -15px; right: -50px" /> -->
          </a>
        </div>
        <div class="col-md-6 align-self-center">
          <!--
         
          <div class="select-languages">
           <div class="form">
             <select style="border-color: #fff !important;">
               <option value="English">English</option>
               <option value="Chines">Chinese</option>
               <option value="French">French</option>
             </select>
           </div>
            <div class="img-wrapper">
              <i class="fa-solid fa-circle-question"></i>
            </div>
          </div> -->
        </div>
      </div>

      <div class="row main-header" v-if="mainHeader === true">
        <div class="col-md-6 align-self-end">
          <RouterLink to="/home" class="logo position-relative">
            <!--<img v-if="profile?.businessLogo" :src="profile?.businessLogo" style="width: 180px !important;" /> -->
            <img  src="../assets/images/ppt/pavicon_final_logo.png" alt="" style="width: 100px !important; height: 15px !important">
            <p class="fw-bold" style="margin-bottom: -20px !important; font-size: 12px !important; text-transform: uppercase !important" >{{ profile?.systemName ? profile.systemName   : 'Inventory & W/H Management System' }} </p>     </RouterLink>
        </div>
        
        <div class="col-md-6 align-self-end">
          <ul class="info">
           
            <li class="mt-2 user-menu-container">
              <div class="user-dropdown">
                <button class="user-trigger" @click="toggleUserMenu">
                  <span class="user-name">{{ user?.name }}</span>
                  <span class="caret">▾</span>
                </button>
                <ul v-if="userMenuOpen" class="user-dropdown-menu">
                  <li @click="goToProfile">Profile</li>
                  <li class="user-toggle" @click.stop="toggleDarkMode">
                    <span>{{ isDarkMode ? 'Dark' : 'Light' }} mode</span>
                    <input type="checkbox" :checked="isDarkMode" readonly />
                  </li>
                  <li @click="logout">Log Out</li>
                </ul>
              </div>
            </li>
             
            <li>
              <div class="bell-icon" style="position: relative; cursor: pointer;" @click="showNotifications">
                <img src="../assets/images/icons/bell1.png" style="width: 25px !important; height: auto !important;" alt="Notifications">
                <span v-if="approvals && (user?.Permission?.approveTransfer  || 
                  user?.Permission?.approveAll || 
                  user?.Permission?.approveDispatch ||
                  user?.Permission?.approvePickup ||
                  user?.Permission?.approveAdjustment||
                  user?.Permission?.approvePurchase
                )" class="counter notification-badge" @click.stop="$router.push('/settings/approvals')">
                  {{ countPendingApprovals(this.approvals) }}
                </span>
              </div>
            </li>
            <!--<li>
              <div class="question-mark" style="cursor: pointer;">
                <img src="../assets/images/icons/question-mark-circle.png" style="width: 25px !important; height: auto !important;" alt="">
              </div>
            </li>-->
          </ul>
        </div>
        <div class="col-md-8 align-self-end" style="margin-top: 5px;">
          
          <ul class="menu main-nav">
            <li v-if="user?.Permission?.dashboard"><RouterLink to="/home">Home</RouterLink></li>
            <li  v-if="user?.Permission?.transaction" >
              <RouterLink to="#" @click="menuDropdown3">Transactions
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
            </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle3" >
                <li><RouterLink to="/transaction">BPN Transactions</RouterLink></li>
                <li><RouterLink to="/transaction/incompletenotes">Incomplete Delivery Notes</RouterLink></li>
              </ul>
            </li>
            <li>
              <RouterLink to="#" @click="menuDropdown2">Inventory
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle2" >
                <li><RouterLink to="/inventory/stocks">Manage Stock Levels</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/markedreturn">Manage Returns</RouterLink></li>
                <li class="mt-2"><RouterLink to="/warehouses/locate">Locate Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/products">View Products</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/products/add">Add Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/adjustments">Stock Adjustment</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/transfers">Stock Transfer</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/reserveds">Stock Reserve</RouterLink></li>
              </ul>
            </li>
            <li>
              <RouterLink to="#" @click="menuDropdown4">Warehouse
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle4" >
                <li v-if="user?.Permission?.batchAdd"><RouterLink to="/transaction/addbatch">Add Stock/Batch Processing</RouterLink></li>
                <li class="mt-1"><RouterLink to="/warehouses/locate">Locate Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/markedreturn">Manage Returns</RouterLink></li>
                <li v-if="user?.Permission?.warehouseView" class="mt-1"><RouterLink to="/warehouses">View Warehouses</RouterLink></li>
                <li v-if="user?.Permission?.warehouseAdd" class="mt-1"><RouterLink to="/warehouses/add">Add Warehouse</RouterLink></li> 
                <li v-if="user?.Permission?.warehouseManage" class="mt-1"><RouterLink to="/warehouses/virtual">Manage Virtual Warehouses</RouterLink></li>
              </ul>
            </li>
            <li v-if="user?.Permission?.purchaseView">
              <RouterLink to="#" @click="menuDropdown5">Purchases
                <svg fill="
                #000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle5" >
                        <li v-if="user?.Permission?.purchaseView && user?.Permission?.purchaseRequestAdd" class="mt-1"><RouterLink to="/transaction/purchase-request/add">Purchase Requisition</RouterLink></li>
                <li v-if="user?.Permission?.purchaseView && user?.Permission?.purchaseRequestProcess"><RouterLink to="/transaction/purchase-request">Manage Purchase Requests</RouterLink></li>
                <li v-if="user?.Permission?.purchaseView"><RouterLink to="/purchases">Manage Purchase Orders</RouterLink></li>
                <li v-if="user?.Permission?.purchaseAdd" class="mt-1"><RouterLink to="/purchases/add">Add Purchase Orders</RouterLink></li>
              </ul>
            </li>
            <li v-if="user?.Permission?.supplierView">
              <RouterLink to="#" @click="menuDropdown6">Suppliers
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle6" >
                <li v-if="user?.Permission?.supplierView"><RouterLink to="/suppliers">Manage Suppliers</RouterLink></li>
                <li v-if="user?.Permission?.supplierAdd" class="mt-1"><RouterLink to="/suppliers/add">Add Suppliers</RouterLink></li>
              </ul>
            </li>
            <li>
              <RouterLink to="#" @click="menuDropdown1">Orders
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle1" >
                <li v-if="user?.Permission?.dispatchProcess"><RouterLink to="/orders">Manage Orders</RouterLink></li>
                <li v-if="user?.Permission?.dispatchProcess"><RouterLink to="/orders/process">Process Orders</RouterLink></li>
                <li v-else><RouterLink to="/orders">View  Orders</RouterLink></li>
                <li v-if="user?.Permission?.pickupAdd" class="mt-1"><RouterLink to="/orders/pickup/add">Generate Pickup Order</RouterLink></li>
                <li v-if="user?.Permission?.dispatchAdd" class="mt-1"><RouterLink to="/orders/dispatch/add">Generate Dispatch Order</RouterLink></li>
                <li class="mt-1"><RouterLink to="/orders/cancelled">View Cancelled Orders</RouterLink></li>
              </ul>
            </li>
            <li>
              <RouterLink to="/reports">Reports</RouterLink>
            </li>
            <li v-if="user?.Permission?.dashboard && user?.Permission?.tenderManage">
              <RouterLink to="#" @click="menuDropdown7">Tenders
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </RouterLink>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle7" >
                <li><RouterLink to="/admin/tenders">Manage Tenders</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders/add">Add Tender</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders/submissions">Tender Submissions</RouterLink></li>
              </ul>
            </li>
            <li v-if="user?.Permission?.usersAdd"><RouterLink to="/settings">Settings</RouterLink></li>
          </ul>
        </div>
        <!--
          <div class="col-md-1">
          <div class="btn-group" role="group" style="float:right; margin-top: 5px;margin-right: -40px;">
            <button type="button" class="btn btn-default btn-sm dropdown-toggle" style="border: 1px solid black;" data-bs-toggle="dropdown" aria-expanded="false">Select System</button>
            <ul class="dropdown-menu">
              <li style="width: 100%;"><a class="dropdown-item" href="#">Inventory And Warehouse System</a></li>
            </ul>
          </div>
        </div>
        
        <div class="col-md-3 align-self-end">
          <div class="search-form">
            <input type="text" placeholder="Search...">
            <input type="submit" id="HeaderSearch">
            <label for="HeaderSearch">
              <i class="fas fa-search"></i>
            </label>
          </div>
        </div>
        -->
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { useDarkMode } from '../composables/useDarkMode'

export default {
  name: 'FooterComponent',
  props: ['loginHeader', 'mainHeader'],
  setup() {
    const { isDarkMode, toggleDarkMode } = useDarkMode()
    return {
      isDarkMode,
      toggleDarkMode
    }
  },
  data: () => ({
    token: localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : null,
    user: "",
    
    menuDropdownShow1: false,
    menuDropdownShow2: false,
    menuDropdownShow3: false,
    menuDropdownShow4: false,
    menuDropdownShow7: false,
    menuDropdownStyle1: { display: 'none'},
    menuDropdownStyle2: { display: 'none'},
    menuDropdownStyle3: { display: 'none'},
    menuDropdownStyle4: { display: 'none'},
    menuDropdownStyle5: { display: 'none'},
    menuDropdownStyle6: { display: 'none'},
    menuDropdownStyle7: { display: 'none'},
    menuDropData:{
      display: 'grid',
      background: '#fff', 
      position: 'absolute',
      'list-style': 'grid',
      padding: '15px',
      'margin-left': '-15px',
      'border-radius': '5px',
      'border':'1px solid #d2d2d2',
      opacity: '1',
      'z-index': 2,
    },
    businessLogo: "",
    systemName: "",
    urlServer:process.env.VUE_APP_URL,
    userMenuOpen: false,
    approvalsInterval: null,
  }),


  computed:{
    ... mapGetters (["getApprovals", "getProfile"]),
    approvals () { return this.getApprovals },
    profile() { return this.getProfile },
    showHeader() {
      return !this.$route?.meta?.public;
    },
  }, 

  methods: {
    ... mapActions(['fetchApprovals', 'fetchProfile']),
    menuDropdown1 () { 
      this.resetDropdowns()
      this.menuDropdownShow1 = !this.menuDropdownShow1;
      if(this.menuDropdownShow1) { this.menuDropdownStyle1 = this.menuDropData } else { this.menuDropdownStyle1 = { display: 'none' }}
    },
    menuDropdown2 () { 
      this.resetDropdowns()
      this.menuDropdownShow2 = !this.menuDropdownShow2;
      if(this.menuDropdownShow2) { this.menuDropdownStyle2 = this.menuDropData } else { this.menuDropdownStyle2 = { display: 'none' }}
    },
    menuDropdown3 () { 
      this.resetDropdowns()
      this.menuDropdownShow3 = !this.menuDropdownShow3;
      if(this.menuDropdownShow3) { this.menuDropdownStyle3 = this.menuDropData } else { this.menuDropdownStyle3 = { display: 'none' }}
    },
    menuDropdown4 () { 
      this.resetDropdowns()
      this.menuDropdownShow4 = !this.menuDropdownShow4;
      if(this.menuDropdownShow4) { this.menuDropdownStyle4 = this.menuDropData } else { this.menuDropdownStyle4 = { display: 'none' }}
    },
    menuDropdown5 () { 
      this.resetDropdowns()
      this.menuDropdownShow5 = !this.menuDropdownShow5;
      if(this.menuDropdownShow5) { this.menuDropdownStyle5 = this.menuDropData } else { this.menuDropdownStyle5 = { display: 'none' }}
    },
    menuDropdown6 () { 
      this.resetDropdowns()
      this.menuDropdownShow6 = !this.menuDropdownShow6;
      if(this.menuDropdownShow6) { this.menuDropdownStyle6 = this.menuDropData } else { this.menuDropdownStyle6 = { display: 'none' }}
    },
    menuDropdown7 () { 
      this.resetDropdowns()
      this.menuDropdownShow7 = !this.menuDropdownShow7;
      if(this.menuDropdownShow7) { this.menuDropdownStyle7 = this.menuDropData } else { this.menuDropdownStyle7 = { display: 'none' }}
    },
    resetDropdowns(){
      this.menuDropdownStyle1 = { display: 'none'}
      this.menuDropdownStyle2 = { display: 'none'}
      this.menuDropdownStyle3 = { display: 'none'}
      this.menuDropdownStyle4 = { display: 'none'}
      this.menuDropdownStyle5 = { display: 'none'}
      this.menuDropdownStyle6 = { display: 'none'}
      this.menuDropdownStyle7 = { display: 'none'}
    },

    showNotifications() {
      // TODO: Implement notification logic (open dropdown, modal, etc.)
      alert('Show notifications here');
    },
    async setupUser(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/users/profile', requestOptions)
        const data = await res.json()
        if(data.status == true){
          this.user = data.user;
          localStorage.setItem('permission', JSON.stringify(data.user.Permission))
          localStorage.setItem('userId', JSON.stringify(data.user.id))
        }else{
          this.$router.push("/")
        }
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen
    },
    goToProfile() {
      this.userMenuOpen = false
      this.$router.push('/settings/profile')
    },
    logout() {
      this.userMenuOpen = false
      this.$router.push('/')
    },
  },
  async mounted(){
   
    //const profileData = localStorage.getItem('profile');
    //this.profile = profileData && profileData !== 'undefined' ? JSON.parse(profileData) : null;
    this.businessLogo = this.profile?.businessLogo
    this.systemName = this.profile?.systemName
    // Only fetch protected data when not on a public route and when a token exists in localStorage
    try {
      const currentToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : null;
      this.token = currentToken;
    
        await this.setupUser()
        await this.fetchApprovals()
        await this.fetchProfile()

        console.log('Header mounted', this.profile);
        // start polling approvals every 5 minutes
        try {
          this.approvalsInterval = setInterval(() => {
            this.fetchApprovals().catch(e => console.error('Failed to poll approvals', e));
          }, 5 * 60 * 1000); // 5 minutes
        } catch (e) {
          console.error('Failed to start approvals polling', e);
        }
      
    } catch (e) {
      // ignore parse errors and avoid blocking mount
    }
  },
  beforeUnmount() {
    if (this.approvalsInterval) {
      clearInterval(this.approvalsInterval);
      this.approvalsInterval = null;
    }
  },
  watch:{
    $route() {
      this.resetDropdowns();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info li{
  margin-right: 10px !important;
}

.info{
  padding: 10px !important;
}
.menu-dropdown li,a{
  color: #000 !important;
  cursor: pointer;
}
.menu-dropdown{
  margin-top: 22px;
}

.menu-dropdown li:hover{
  background-color: #d2d2d2;
}

.user-menu-container { position: relative; }
.user-dropdown { position: relative; }
.user-trigger { background: transparent; border: none; color: inherit; cursor: pointer; font-size: 14px; display:inline-flex; align-items:center; gap:6px; }
.user-name { font-weight: 600; }
.user-dropdown-menu { position: absolute; right: 0; top: 28px; background: #fff; list-style: none; padding: 8px 0; margin: 0; border: 1px solid #d2d2d2; border-radius: 4px; min-width: 120px; z-index: 50; }
.user-dropdown-menu li { padding: 8px 12px; cursor: pointer; color: #000; }
.user-dropdown-menu li:hover { background: #f2f2f2 }

.user-toggle{ display:flex; align-items:center; justify-content:space-between; padding:8px 12px; }
.user-toggle input{ pointer-events:none }

.notification-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 22px;
  height: 22px;
  background: #e74c3c;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 0 2px #333;
  padding: 0 6px;
}

</style>
